import { Navigate } from "react-router";

import { useTenant } from "@/hooks/useTenant";

/** `/ordering` (the planned "Need to order" page until Purchase demand shipped): the section's first page this member may use. */
export function OrderingIndex() {
  const { can } = useTenant();
  const to = can("purchasing.view_orders") ? "demand" : can("receiving.receive") ? "receiving" : can("inventory.view_stock") ? "inventory" : "locations";
  return <Navigate to={to} replace />;
}
